/**
 * @prettier
 */

import { browserHistory } from 'react-router';
import { addItemV2, getCart } from 'actions/CartActions';
import { ActionTypes as CardCatalogActionTypes } from 'cards/actions/cardCatalogActions';
import { getAvailableSamplesCount } from 'cards/components/common/SingleSample/util/api';

// TODO: when BE offers a field to use to add samples to cart

export const addSpecialTypeSampleToCart = sampleSku => {
  if (!sampleSku) {
    return {};
  }

  return dispatch => {
    dispatch(
      addItemV2({
        sku_id: sampleSku,
        quantity: 1,
        item_origin: 'WEDDINGS',
      })
    ).then(() => {
      window.dispatchEvent(new CustomEvent('NAV_UPDATE_CART_SIZE'));
      dispatch(getCart());
    });
  };
};

// Calling setMultiSampleEnabled without the `enabled` argument will set multi sample mode to
// the `multi_sample_mode` query param state in the URL.
export const setMultiSampleEnabled = (cardType, enabled = null) => {
  return dispatch => {
    const { query, pathname } = browserHistory.getCurrentLocation();

    let isMultiSampleMode = false;

    if (query && query.multi_sample_mode === 'multisampleenabled') {
      isMultiSampleMode = true;
    }

    if (enabled !== null) {
      isMultiSampleMode = enabled;
    }

    const newQuery = { ...query };

    if (isMultiSampleMode) {
      newQuery.multi_sample_mode = 'multisampleenabled';
    } else {
      delete newQuery.multi_sample_mode;
    }

    const queryString = Object.keys(newQuery)
      .map(k => `${k}=${newQuery[k]}`)
      .join('&');

    const search = `?${queryString}`;

    browserHistory.push({
      pathname,
      search,
    });

    let samplesCountPromise;

    if (cardType) {
      samplesCountPromise = getAvailableSamplesCount(cardType);
    } else {
      samplesCountPromise = Promise.resolve({ order_placed: 0, maximum_orders_allowed: 5 });
    }

    return samplesCountPromise.then(result => {
      const count = {
        ordersPlaced: result.order_placed,
        maximumOrdersAllowed: result.maximum_orders_allowed,
      };

      dispatch({
        type: CardCatalogActionTypes.SET_MULTISAMPLE_ENABLED,
        payload: { enabled: isMultiSampleMode, count },
      });
      // * re-fetch content w/wo sample available content if applicable
      if (enabled !== null) {
        dispatch({
          type: CardCatalogActionTypes.UPDATE_SEARCH_FILTERS,
          payload: { key: 'single_sample_available', value: isMultiSampleMode },
        });
      }

      return Promise.resolve();
    });
  };
};

export const setMultiSampleSelected = (card, selected, initialColor = null) => {
  return {
    type: CardCatalogActionTypes.SET_MULTISAMPLE_SELECTED,
    payload: { card, selected, initialColor },
  };
};
